import dayjs from "dayjs";

export const RX_FREQS = ["Once daily (QD)", "Twice daily (BID)", "Three times daily (TID)", "Four times daily (QID)",
  "Every 4 hours (Q4H)", "Every 6 hours (Q6H)", "Every 8 hours (Q8H)", "At bedtime (HS)",
  "Before meals (AC)", "After meals (PC)", "As needed (PRN)", "Weekly", "Monthly"];
export const QTY_UNITS = ["tablets", "capsules", "mL", "films", "patches", "grams", "inhalers", "vials", "syringes", "units"];
const UNIT_FOR_FORM = { Tablet: "tablets", Capsule: "capsules", Liquid: "mL", Solution: "mL", Suspension: "mL",
  "Sublingual Film": "films", Patch: "patches", Cream: "grams", Ointment: "grams", Gel: "grams", Inhaler: "inhalers" };
export const unitForForm = (form) => UNIT_FOR_FORM[form] || "";

export const STATUS_TONE = {
  draft: "bg-[#EFEBE0] text-[#6D4C41]", signed: "bg-[#E3F2FD] text-[#1565C0]", printed: "bg-[#F3E5F5] text-[#6A1B9A]",
  emailed: "bg-[#E0F2F1] text-[#00695C]", called_in: "bg-[#FFF3E0] text-[#8D5A00]", completed: "bg-[#E8F5E9] text-[#2E7D32]",
  voided: "bg-[#FFEBEE] text-[#C62828]",
};

export const fmtDate = (d) => (d ? dayjs(d).format("MMM D, YYYY") : "-");
export const fmtDateTime = (d) => (d ? dayjs(d).format("MMM D, YYYY h:mm A") : "-");

export const lineLabel = (l) => [l.medication, l.strength, l.form].filter(Boolean).join(" ");
export const todayIso = () => dayjs().format("YYYY-MM-DD");
export const linePharmacy = (rx, l) => ("pharmacy" in l ? l.pharmacy : rx.pharmacy) || null;
export const pharmacyAddress = (p) => [p.address, p.city, [p.state, p.zip].filter(Boolean).join(" ")].filter(Boolean).join(", ");
export const LINE_TONE = { Voided: STATUS_TONE.voided, Discontinued: "bg-[#EFEBE0] text-[#6D4C41] ring-1 ring-[#C62828]/40" };

export function sigText(l) {
  let t = l.directions || l.frequency || "";
  if (l.directions && l.frequency && !l.directions.toLowerCase().includes(l.frequency.toLowerCase())) t = `${l.directions} (${l.frequency})`;
  return l.prn && !/prn|needed/i.test(t) ? `${t}, as needed` : t;
}

export function RxStatusChip({ rx, testId }) {
  return <span data-testid={testId} className={`rounded-full px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wide ${STATUS_TONE[rx.status] || STATUS_TONE.draft}`}>{rx.status_label || rx.status}</span>;
}

export function ScheduleChip({ schedule }) {
  if (!schedule) return null;
  return <span className="rounded-full bg-[#FFEBEE] px-1.5 py-0.5 text-[9px] font-bold uppercase text-[#C62828]">Schedule {schedule}</span>;
}
